(ns com.theplantscape.plant-web.pages.missing-page
  (:require [com.theplantscape.web-ui.tailwind.ensemble :refer [ui-missing]]
            [com.theplantscape.plant-web.pages.logout-page :refer [ui-page-logout ui-page-unauthorized]]))


(defn ui-page-missing [path]
  [ui-missing])

(defn ui-page-not-authorized [data]
  (when (nil? data)
    [ui-page-unauthorized]
    #_[:p "You are not logged int or your authentication has expired please login"]))
